/**
 * The canonical model names.
 */
export enum URModel {
  UR5 = 'UR5',
  UR8_LONG = 'UR8_LONG', // UR7_LONG is an early prototype of this model
  UR10 = 'UR10',
  UR20 = 'UR20',
}
